import React from 'react';

/**
 * Button atom — primary | secondary | outline | ghost | link.
 */
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  startIcon,
  endIcon,
  className = '',
  type = 'button',
  disabled = false,
  onClick,
  ...props
}) {
  const classes = [
    'ca-btn',
    `ca-btn--${variant}`,
    size === 'sm' ? 'ca-btn--sm' : '',
    size === 'lg' ? 'ca-btn--lg' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {startIcon ? <span className="ca-btn__icon">{startIcon}</span> : null}
      {children}
      {endIcon ? <span className="ca-btn__icon">{endIcon}</span> : null}
    </button>
  );
}
